
import { IDetailedFinancingNeed, IFinancingNeedItemReport } from '@/types/processingSteps'
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { IProject } from "@/types/projects"
import FormContainer from "@/components/processing_steps/commons/forms/FormContainer.vue"

@Component({
  components: { FormContainer }
})
export default class FinanceTable extends Vue {
  @Prop() financingNeedReportItems!: IFinancingNeedItemReport[]
  @Prop() project: IProject

  investionSum = 0
  operatingCostsSum = 0
  staffCostsSum = 0
  otherCostsSum = 0

  get detailedFinancingNeed(): IDetailedFinancingNeed {
    return this.project.detailed_financing_need
  }

  get totalCalculationDeviation(): number {
    return [
      this.calcDeviation(this.investionSum, this.detailedFinancingNeed.investments),
      this.calcDeviation(this.operatingCostsSum, this.detailedFinancingNeed.operating_costs),
      this.calcDeviation(this.staffCostsSum, this.detailedFinancingNeed.staff_costs),
      this.calcDeviation(this.otherCostsSum, this.detailedFinancingNeed.other_costs)
    ].reduce((a, b) => a + b, 0)
  }

  calcDeviation(actual: number, needItem: { need_in_cents: string }): number {
    return actual - (parseInt(needItem.need_in_cents) / 100)
  }

  formatCurrency(value: number): string {
    return value.toLocaleString('de-DE', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }) + ' €'
  }

  get calculationSum(): number {
    return this.investionSum + this.operatingCostsSum + this.staffCostsSum + this.otherCostsSum
  }

  get budgetSum(): number {
    return [
      parseInt(this.detailedFinancingNeed.investments.need_in_cents),
      parseInt(this.detailedFinancingNeed.operating_costs.need_in_cents),
      parseInt(this.detailedFinancingNeed.staff_costs.need_in_cents),
      parseInt(this.detailedFinancingNeed.other_costs.need_in_cents)
    ].reduce((a, b) => a + b, 0) / 100
  }

  mounted() {
    this.setReportItemExpenseSumPerType()
  }

  @Watch('financingNeedReportItems', { immediate: true, deep: true })
  onFinancingNeedItemsChanged() {
    this.setReportItemExpenseSumPerType()
  }

  setReportItemExpenseSumPerType() {
    const sums = {
      1: 0,
      2: 0,
      3: 0,
      4: 0
    }
    for (const item of this.financingNeedReportItems) {
      if (Object.prototype.hasOwnProperty.call(sums, item.expense_type)) {
        sums[item.expense_type] += item.expense_amount
      }
    }
    this.investionSum = sums[1]
    this.operatingCostsSum = sums[2]
    this.staffCostsSum = sums[3]
    this.otherCostsSum = sums[4]
  }
}
